import { memo, useCallback, useMemo } from "react";
import type { SiteUser } from "@src/features/settings/data/mock-sites";
import { List } from "./List";
import { Text, View } from "@src/components";
import { useUnistyles } from "react-native-unistyles";
import { Icon } from "@src/components/Icon";
import { toSentenceCase } from "@visioni/a3s-ui/utils";

type CameraUsersListProps = {
  users: SiteUser[];
  onPress?: (userId: string) => void;
};

export const CameraUsersList = memo(({ users, onPress }: CameraUsersListProps) => {
  const { theme } = useUnistyles();

  const roleById = useMemo(() => new Map(users.map((u) => [u.id, u.role])), [users]);

  const renderRight = useCallback(
    (item: { id: string }) => {
      const role = roleById.get(item.id);
      return (
        <View flexDirection="row" alignItems="center" gap="xs">
          <Text textStyle="xs/regular" style={{ color: theme.colors.textSecondary }}>
            {role ? toSentenceCase(role) : ""}
          </Text>
          <Icon name="chevronRight" color={theme.colors.textSecondary} />
        </View>
      );
    },
    [theme, roleById],
  );
  if (users.length === 0) {
    return (
      <Text textStyle="sm/regular" color="textMuted" textAlign="center">
        No users found
      </Text>
    );
  }
  return <List items={users} onItemPress={onPress} renderRight={renderRight} />;
});
